import React, { useCallback, useEffect, useState } from 'react'

import { Grid, Input, Span } from 'components'
import { useMovement } from 'hooks'
import { COLORS, FONTS, SPACING, TYPOGRAPHY } from 'utils'

interface IEfetivoNumero {
  isDataExpirada: boolean
  consolidacaoFechada: boolean //Adicione esta prop
}

const EfetivoNumero: React.FC<IEfetivoNumero> = ({
  isDataExpirada,
  consolidacaoFechada //Adicione esta prop 
}) => {
  const {
    movState,
    parametrization,
    setMovState,
    setErrorsTotalVision,
    dataAtuacaoInvalida,
    errorsTotalVision,
    isSomenteCompartilhado,
    isSemMobilizacao,
    isComMobilizacao, //incluido com o merge
  } = useMovement()
  /*
   *
   * PARAMS
   *
   *
   */
  const varMin = parametrization?.vlJustVariacaoMinEfetivo // MIN %
  const varMax = parametrization?.vlJustVariacaoMaxEfetivo // MAX %
  const homenMax = parametrization?.vlJustVariacaoNumHomemMax // MAX HOMENS
  const homenMin = parametrization?.vlJustVariacaoNumHomemMin // MIN HOMENS
  /*
   *
   * PARAMS
   *
   *
   */

  /*
   *
   * BLOQUEIO INPUT
   *
   *
   */
  const [blockInputJustify, setBlockInputJustify] = useState<boolean>(true)

  const handleChange = (e: React.ChangeEvent<HTMLInputElement>) => {
    setMovState((old) => ({
      ...old,
      visaoTotal: {
        ...old.visaoTotal,
        [e.target.name]: e.target.value
      }
    }))
  }

  const handleBlockInput = useCallback(() => {
    if (movState.flStatusMobilizacao === '0') return
    //formulario
    const varAtual = Number(movState?.visaoTotal?.peNePercVarAtual) // %
    const varHomens = movState?.visaoTotal?.vlNeVariacaoAtual // HOMENS

    if (
      varAtual < varMin ||
      varHomens < homenMin ||
      varAtual > varMax ||
      varHomens > homenMax
    ) {
      setBlockInputJustify(false)
    } else {
      setBlockInputJustify(true)
    }
  }, [
    movState?.visaoTotal?.peNePercVarAtual,
    movState?.visaoTotal?.vlNeVariacaoAtual
  ])
  useEffect(handleBlockInput, [handleBlockInput])
  /*
   *
   * BLOQUEIO INPUT
   *
   *
   */

  /*
   *
   * CALCULO VARIACAO
   *
   *
   */
  const handleCalcVl = useCallback(() => {
    //LINHA 3 EFETIVO NUMERO

    // Para o campo Variação (Real)
    // Utilizar o calculo [ variacaoReal = mesAtual - mesAnterior]
    // Ex1.: No mês anterior tinhamos 5 efetivos, e no mes atual temos 10, logo 10 - 5 = 5 efetivos (positivo) de variação
    // Ex2.: No mês anterior tinhamos 10 efetivos, e no mes atual temos 5, logo 5 - 10 = (-5) efetivos (negativo) de variação

    const vlNeVariacaoAtual = movState.visaoTotal?.vlNeVariacaoAtual;
    if (!vlNeVariacaoAtual || typeof vlNeVariacaoAtual === 'number') {
      //if (!movState.visaoTotal?.vlNeVariacaoAtual) {
      const calcVl =
        movState.visaoTotal?.qtNeAtual - movState.visaoTotal?.qtNeAnterior

      setMovState((old) => ({
        ...old,
        visaoTotal: {
          ...old.visaoTotal,
          vlNeVariacaoAtual: calcVl || 0
        }
      }))
    }

    // Para o campo Variação (%)
    // Caso o valor de mesAnterior seja 0 e o valor de mesAtual seja <> 0, utilizar 100.00 (%)
    if (
      movState.visaoTotal?.qtNeAnterior === 0 &&
      movState.visaoTotal?.qtNeAtual !== 0
    ) {
      setMovState((old) => ({
        ...old,
        visaoTotal: {
          ...old.visaoTotal,
          peNePercVarAtual: 100
        }
      }))
    }
    // Caso o valor de mesAnterior seja <> 0 e o valor de mesAtual seja 0, utilizar -100.00 (%) (negativo)
    else if (
      movState.visaoTotal?.qtNeAnterior != 0 &&
      movState.visaoTotal?.qtNeAtual === 0
    ) {
      setMovState((old) => ({
        ...old,
        visaoTotal: {
          ...old.visaoTotal,
          peNePercVarAtual: '-100'
        }
      }))
    }
    // Caso o valor de mesAnterior E mesAtual sejam 0, utilizar 0.0 (%)
    else if (
      movState.visaoTotal?.qtNeAnterior === 0 &&
      movState.visaoTotal?.qtNeAtual === 0
    ) {
      setMovState((old) => ({
        ...old,
        visaoTotal: {
          ...old.visaoTotal,
          peNePercVarAtual: 0
        }
      }))
    }
    // Caso qualquer outro cenário, utilizar o calculo:
    // ((mesAtual - mesAnterior) / mesAnterior) * 100
    else {
      // Não mexer nesse calculo.
      const calcPe =
        ((movState?.visaoTotal?.qtNeAtual -
          movState?.visaoTotal?.qtNeAnterior) /
          movState?.visaoTotal?.qtNeAnterior) *
        100
      // ________^

      setMovState((old) => ({
        ...old,
        visaoTotal: {
          ...old.visaoTotal,
          peNePercVarAtual: calcPe || 0
        }
      }))
    }
    // Ex: ((1 - 5) / 5 ) * 100 --> ( -4 / 5) * 100 = (-80)%
  }, [
    movState?.visaoTotal?.peNePercVarAtual,
    movState.visaoTotal?.qtNeAtual,
    movState.visaoTotal?.qtNeAnterior,
    movState.visaoTotal?.vlNeVariacaoAtual
  ])
  useEffect(handleCalcVl, [handleCalcVl])
  /*
   *
   * CALCULO VARIACAO
   *
   *
   */

  //Também modifique a função handleVerificacao para não mostrar erros quando consolidação fechada
  const handleVerificacao = useCallback(() => {
    // if (movState.flStatusMobilizacao === '0') {
    //   setErrorsTotalVision((old) => ({
    //     ...old,
    //     txNeJustificativa: null
    //   }))
    //   return
    // }

    if (consolidacaoFechada) {
      setErrorsTotalVision((old) => ({
        ...old,
        txNeJustificativa: null
      }))
      return
    }

    setErrorsTotalVision((old) => ({
      ...old,
      txNeJustificativa: null
    }))

    //formulario
    const varAtual = Number(movState?.visaoTotal?.peNePercVarAtual) // %
    const varHomens = movState?.visaoTotal?.vlNeVariacaoAtual // HOMENS

    const qtdDeAcesso = movState?.visaoTotal?.qtAcesso
    const qtdDeDemitido = movState?.visaoTotal?.qtDemitido
    const qtdDeTransferido = movState?.visaoTotal?.qtTransferido
    const qtdDeAfastado = movState?.visaoTotal?.qtAfastado
    const qtdDeAtivos = movState?.visaoTotal?.qtAtivo

    if (
      (varAtual < varMin ||
        varHomens < homenMin ||
        varAtual > varMax ||
        varHomens > homenMax) && !dataAtuacaoInvalida
    ) {

      if (
        (isComMobilizacao) &&
        !movState?.visaoTotal?.txNeJustificativa &&
        !isSemMobilizacao &&
        movState.isCompetenciaAtual &&
        (varAtual > 20 || varAtual < -20 || varHomens > 10 || varHomens < -10)
      ) {
        setErrorsTotalVision((old) => ({
          ...old,
          txNeJustificativa: {
            message: 'Obrigatório justificar!'
          }
        }))

        if (dataAtuacaoInvalida) {
          setErrorsTotalVision((old) => ({
            ...old,
            txNeJustificativa: null
          }))
        }
      } else if (
        (isSemMobilizacao || isComMobilizacao) &&
        movState?.visaoTotal?.txNeJustificativa &&
        movState?.visaoTotal?.txNeJustificativa.length < 30 &&
        movState.isCompetenciaAtual
      ) {
        setErrorsTotalVision((old) => ({
          ...old,
          txNeJustificativa: {
            message: 'Justificativa mínima de 30 caracteres!'
          }
        }))

        if (dataAtuacaoInvalida) {
          setErrorsTotalVision((old) => ({
            ...old,
            txNeJustificativa: null
          }))
        }
      } else if (
        (isSemMobilizacao || isComMobilizacao) &&
        movState?.visaoTotal?.txNeJustificativa &&
        movState?.visaoTotal?.txNeJustificativa.length > 2048 &&
        movState.isCompetenciaAtual
      ) {
        setErrorsTotalVision((old) => ({
          ...old,
          txNeJustificativa: {
            message: 'Justificativa maxima de 2048 caracteres!'
          }
        }))

        if (dataAtuacaoInvalida) {
          setErrorsTotalVision((old) => ({
            ...old,
            txNeJustificativa: null
          }))
        }
      } else {
        setErrorsTotalVision((old) => ({
          ...old,
          txNeJustificativa: null
        }))
      }
    } else {
      setErrorsTotalVision((old) => ({
        ...old,
        txNeJustificativa: null
      }))
    }

    if (
      (isSemMobilizacao && !movState?.visaoTotal?.txNeJustificativa) &&
      movState?.visaoTotal?.qtNeAnterior && !dataAtuacaoInvalida
    ) {
      setErrorsTotalVision((prevState) => ({
        ...prevState,
        txNeJustificativa: {
          message: 'Obrigatório justificar!'
        }
      }))
    }

    if (dataAtuacaoInvalida) {
      setErrorsTotalVision((old) => ({
        ...old,
        txNeJustificativa: null
      }))
    }
  }, [
    consolidacaoFechada, //Adicione na dependência
    movState?.visaoTotal?.txNeJustificativa,
    movState?.visaoTotal?.peNePercVarAtual,
    movState?.visaoTotal?.vlNeVariacaoAtual,
    movState?.visaoTotal?.qtNeAnterior,
    dataAtuacaoInvalida
  ])

  const blockJustify = (): boolean => {
    const qtdDeAcesso = movState?.visaoTotal?.qtAcesso
    const qtdDeDemitido = movState?.visaoTotal?.qtDemitido
    const qtdDeTransferido = movState?.visaoTotal?.qtTransferido
    const qtdDeAfastado = movState?.visaoTotal?.qtAfastado
    const qtdDeAtivos = movState?.visaoTotal?.qtAtivo

    const disableButton = true
    const enableButton = false

    //Adicione esta verificação no início
    if (consolidacaoFechada) {
      return disableButton
    }

    if (isDataExpirada) {
      return disableButton
    }

    if (isSemMobilizacao && movState?.visaoTotal?.qtNeAnterior) {
      return enableButton
    }

    if (blockInputJustify || dataAtuacaoInvalida || isSomenteCompartilhado) {
      return disableButton
    }

    if (!movState.isCompetenciaAtual) {
      return disableButton
    }

    if (qtdDeAtivos == 0 && qtdDeAcesso == 0 && qtdDeDemitido == 0 && qtdDeAfastado == 0 && qtdDeTransferido == 0) {
      return disableButton
    }

    return enableButton
  }

  useEffect(() => {
    handleVerificacao()
  }, [handleVerificacao])

  const getVariacao = () => {
    return parseFloat(movState?.visaoTotal?.peNePercVarAtual as string).toFixed(2) || 0
  }

  return (
    <>
      <Span
        marginTop={SPACING.spacing10}
        marginBottom={SPACING.spacing20}
        text="EFETIVO NÚMERO"
        fontSize={TYPOGRAPHY.bodySize16}
        fontWeight={FONTS.bold}
        color={COLORS.black}
      />
      <Grid
        gridCols="1fr 1fr 1fr 1fr 3.2fr 1fr"
        gridGap="1rem"
        padding={`0 0 ${SPACING.spacing30}`}
      >
        <Input
          value={movState?.visaoTotal?.qtNeAnterior}
          label="Mês Anterior"
          placeholder="Qtd."
          formValue="qtNeAnterior"
          disabled
        />
        <Input
          value={movState?.visaoTotal?.qtNeAtual}
          label="Mês atual"
          placeholder="Qtd."
          formValue="qtNeAtual"
          disabled
        />
        <Input
          value={getVariacao()}
          label="Variação (%)"
          placeholder="%"
          formValue="peNePercVarAtual"
          disabled
          onChange={handleChange}
        />
        <Input
          value={movState?.visaoTotal?.vlNeVariacaoAtual}
          label="Variação"
          placeholder="Nº de Homens"
          formValue="vlNeVariacaoAtual"
          disabled
          onChange={handleChange}
        />
        <Input
          value={movState?.visaoTotal?.txNeJustificativa}
          label="Justificativa de Variação"
          placeholder="Justifique"
          formValue="txNeJustificativa"
          disabled={blockJustify()}
          customError={errorsTotalVision.txNeJustificativa}
          onChange={handleChange}
        />
      </Grid>
      <Grid gridCols="4fr 3fr 1fr" gridGap="1rem">
        <div />

        <Span
          marginTop="-25px"
          marginLeft="10px"
          text={`Caso seja maior que ${parametrization?.vlJustVariacaoMaxEfetivo}% ou ${parametrization?.vlJustVariacaoNumHomemMax} homens ou menor que ${parametrization?.vlJustVariacaoMinEfetivo}% ou ${parametrization?.vlJustVariacaoNumHomemMin} homens do efetivo`}
          fontSize={TYPOGRAPHY.captionSize12}
          fontWeight={FONTS.light}
          color={COLORS.black}
        />
      </Grid>
    </>
  )
}

export default EfetivoNumero